
<v-touch class="week-day" v-on:press="showOccupation" v-on:panstart="showOccupation" v-on:pancancel="hideOccupation"
  v-on:panend="hideOccupation" v-on:pressup="hideOccupation">
  <div class="week-day-content" @mouseover="showOccupation" @mouseout="hideOccupation" @mouseleave="hideOccupation">
    <div class="week-day-number" @click='clickDay()'>{{ day.day }}</div>
    <div v-if="getCountNewStateByDay(day) > 0" class="week-day-newResa">{{ getCountNewStateByDay(day) }}</div>
    <el-popover placement="right" v-model="popover" trigger="click" popper-class="popup-delete black-inputs">
      <div class="popup-sc-date">{{ day.labelDay }} {{ day.day }} {{ day.labelMonth }}</div>
      <div v-if="!getDaysIsClosed(day.weekday, false, new Date(day.date).getTime())">
        <div class="popup-sc" v-for='(ms, msKey) in getMainServicesForDay(day, true, true)' :key="msKey">
          <div class="popup-sc-sub" v-for='(s, sKey) in ms' :key="sKey">
            <el-row :gutter="0" v-if="s">
              <el-col>
                <div class="popup-sc-sub_name">{{ s.name }}</div>
              </el-col>
              <el-col>
                <span class="popup-sc-sub_name">Ouverture : </span>
                <el-switch v-model="switchers[s.name]" active-color="#5daf8f" inactive-color="#e95d5d"
                  @change="selectSwitcherChange(s)">
                </el-switch>
              </el-col>
              <el-col v-if="cashState(s.name)">
                <div>Avec {{ cashState(s.name).type }} de {{ cashState(s.name).value }} €/couv. <button
                    v-if="!cashState(s.name).isOnService" @click="editCashInfos(day, s.name)">Modifier</button></div>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
      <el-button slot="reference" v-if="!getDaysIsClosed(day.weekday, false, new Date(day.date).getTime())"
        class="week-day-options el-icon-more" circle></el-button>
    </el-popover>
    <popup-discount-display :date="day" :small="true" />
    <div class="week-day-services-container"
      v-if="!getDaysIsClosed(day.weekday, false, new Date(day.date).getTime())">
      <div
        :class="['week-day-services', { 'week-day-services-max': Object.entries(getMainServicesForDay(day, true, true)).length > 4 }]">
        <div class="week-day-service" v-for='(ms, msKey) in getMainServicesForDay(day, true, true)' :key="msKey">
          <div class="week-day-service-sub" v-for='(s, sKey) in ms' :key="sKey">
            <calendar-service :class="isLockedService(s.name)" :ms="s.name" :id="sKey" :length="ms.length" :date="day"
              :visibility="getToolTipVisibility"></calendar-service>
            <div v-if="cashState(s.name)">
              {{ getTypeCash(cashState(s.name).type) }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="week-day-click" @click='clickDay()'></div>
    <div class="week-day-service-closed" v-if="getDaysIsClosed(day.weekday, false, new Date(day.date).getTime())">
      Fermé
    </div>
  </div>
</v-touch>
